export default "__VITE_ASSET__Dtd4$YGz__"